var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper rtl dashboard-shell"},[_c('div',{staticClass:"main-panel"},[_c('top-navbar',{ref:"header"}),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}}),_c('content-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }